<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="720px">
        <v-card>
          <v-card-title class="text-h5">
            <!-- {{ title }} -->
            Details
          </v-card-title>

          <v-card-text>
            <!-- Are you sure you want to delete this message? -->
            <!-- <span v-html="message"></span> -->
            <!-- {{ message }} -->
            <v-container>
              <v-row>
                <!-- <v-col cols="12" class="mt-0 pt-0">
                  <table class="retailer-details">
                    <tr>
                      <td class="w-40">Name:</td>
                      <td>{{ data.firstName }} {{ data.lastName }}</td>
                    </tr>
                    <tr>
                      <td>Mobile Number:</td>
                      <td>{{ data.mobileNumber }}</td>
                    </tr>
                    <tr>
                      <td>City:</td>
                      <td>{{ data.city }}</td>
                    </tr>
                    <tr>
                      <td>Region:</td>
                      <td>{{ data.region }}</td>
                    </tr>
                  </table>
                </v-col> -->
                <!-- <v-col cols="12">
                  <v-btn color="primary" class="ml-auto">
                    <download-csv :data="exportData" :name="`${fileName}.csv`">
                      <v-icon dense>mdi-download</v-icon>
                      Export
                    </download-csv>
                  </v-btn>
                </v-col> -->
                <v-col cols="12">
                  <v-btn color="primary" class="ml-auto">
                    <download-csv :data="exportData" :name="`${fileName}.csv`">
                      <v-icon dense>mdi-download</v-icon>
                      Export
                    </download-csv>
                  </v-btn>
                </v-col>
                <v-col cols="12" class="mt-0 pt-0">
                  <v-data-table
                    :headers="table.headers"
                    :items="table.data.list"
                    :items-per-page="10"
                    :loading="table.loading"
                    item-key="id"
                    loading-text="Loading... Please wait"
                    class="elevation-1"
                  >
                    <template v-slot:[`item.amount`]="{ item }">
                      {{ item.amount.toLocaleString() }}
                    </template>

                    <template v-slot:[`item.name`]="{ item }">
                      {{ item.name ? item.name : "-" }}
                    </template>
                    <template
                      v-for="header in table.headers.filter((header) =>
                        header.hasOwnProperty('formatter')
                      )"
                      v-slot:[`item.${header.value}`]="{ value }"
                    >
                      {{ header.formatter(value) }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <!-- <v-btn text @click.native="cancel">
              No
            </v-btn> -->
            <v-btn @click.native="cancel">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import ShareableMethods from "@/mixins/ShareableMethods";

export default {
  mixins: [ShareableMethods],
  name: "TransactionBreakdown",
  data() {
    return {
      exportData: [],
      fileName: "",

      dialog: false,
      resolve: null,
      reject: null,
      // message: null,
      // title: null,
      // options: {
      //   color: "grey lighten-3",
      //   width: 400,
      //   zIndex: 200,
      //   noconfirm: false,
      // },

      table: {
        // sortBy: "dtCreated",
        sortDesc: true,
        loading: false,

        headers: [
          {
            text: "Date",
            align: "start",
            sortable: false,
            value: "date",
            formatter: (x) => (x ? moment(x).format("MMM DD, YYYY") : null),
          },

          {
            text: "Amount",
            align: "start",
            value: "amount",
            formatter: (x) => this.setToLocaleString(x),
          },
          {
            text: "Type",
            align: "start",
            value: "type",
          },
        ],
        data: [],
      },
    };
  },

  methods: {
    open(data) {
      this.dialog = true;
      // this.title = title;
      // this.message = message;
      this.table.data = data;

      const exportData = data.list.map((item) => {
        return {
          Date: moment(item.date).format("MMM DD, YYYY"),
          Amount: item.amount,
          Type: item.type,
        };
      });
      this.exportData = exportData;
      this.fileName = `${data.retailerId}_${moment(data.date).format(
        "MMM DD, YYYY"
      )}`;
      // this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>
